import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useSSO } from "../context/AuthContext";
import { baseURL } from "./constants";

const useAxios = () => {
  const { login, setApiRes, acquireTokenSilently } = useSSO();

  const axiosInstance = axios.create({ baseURL });

  axiosInstance.interceptors.request.use(async (req) => {
    try {
      const token = await acquireTokenSilently();

      req.headers.Authorization = `Bearer ${token}`;
      return req;

    } catch (error) {
      if (error.errorCode === "interaction_required" ||
        error instanceof InteractionRequiredAuthError) {
        console.warn("Silent refresh failed. Redirecting to login.");

        const token = await login();
        req.headers.Authorization = `Bearer ${token}`;
        return req;
      }

      setApiRes(prev => ({
        ...prev,
        axiosError: true,
        errMsg: JSON.stringify(error),
        errHeading: "MSAL Token Error",
      }));
      throw error;
    }
  });

  return axiosInstance;
};

export default useAxios;